import React from 'react';

import {
  Button,
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import { WysiwygField } from '../../../components';

import './style.scss';

const ParagraphFrame = ({ id, entity, wide }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const link = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const linkTarget = entity.getIn(['field_link', 0, 'options', 'attributes', 'target'], '_self');
  const body = entity.getIn(['field_body', 0, 'processed']);

  return (
    <Container id={id} className="Paragraph ParagraphFrame">
      <div className="row">
        <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          <div className="ParagraphFrame__inner">
            {title && (
              <h4 className="ParagraphFrame__inner__title">{title}</h4>
            )}
            <WysiwygField
              property="schema:text"
              className="ParagraphFrame__body"
              html={body}
            />
            {link && linkTitle && (
              <Button
                href={link}
                className="ParagraphFrame__inner__link"
                target={linkTarget}
                primary={false}
              >
                {linkTitle}
                <div className="icon icon-arrow-right icon-variant-2" />
              </Button>
            )}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphFrame;
